import * as z from 'zod';
import { cloudStorageBucketNameSchema, fileExtensionSchema, fileTypeSchema } from '../../enums.mjs';
import { fileId } from '../../types/opaque.mjs';

var Extract;
(function (Extract) {
    (function (Request) {
        Request.schema = z.object({
            fileId: fileId,
            fileName: z.string(),
            fileExtension: fileExtensionSchema,
            bucket: cloudStorageBucketNameSchema,
            bucketDirPath: z.array(z.string()).optional(),
            generatePdf: z.boolean().optional(),
            emitBondRequestResult: z.boolean().optional(),
            candidateFileType: fileTypeSchema.optional(),
        });
    })(Extract.Request || (Extract.Request = {}));
})(Extract || (Extract = {}));

export { Extract };
